import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { COMPANY } from '../../const/company';
import CompanyRouter from '../CompanyRouter';

import Expired from './pages/Expired';
import QvExpired from './pages/qv/QvExpired';
import DaishinExpired from './pages/daishin/DaishinExpired';
import HyundairsExpired from './pages/hyundairs/HyundairsExpired';

const COMPANY_VIEW = {
  [COMPANY.QV.id]: QvExpired,
  [COMPANY.DAISHIN.id]: DaishinExpired,
  [COMPANY.HYUNDAIRS.id]: HyundairsExpired,
};

@observer
class ExpiredRouter extends Component {
  render() {
    return (
      <CompanyRouter map={COMPANY_VIEW} fallback={Expired} {...this.props} />
    );
  }
}

export default ExpiredRouter;
